import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { resetLastUpdate, setHeaderInMobile, setLocation } from 'src/app/redux/actions/options.action';
import { loadOrdersAllWithPipesSuccess } from 'src/app/redux/actions/order.action';
import { NAVEGATION } from 'src/app/shared/const/navegation';
import { appState } from 'src/app/shared/interfaces/appState.interface';
import { Order } from '@shared-logic/orders';
import { User } from '@shared-logic/user/user.interface';
import { getOrderListWithPipes } from 'src/app/shared/order';
import { MaestrosService } from 'src/app/shared/services/mestros.service';
import { DataRefreshService } from 'src/app/shared/services/data-refresh.service';
import { SessionChecker } from 'src/app/shared/session.checker';
import { TablesIBMClass } from 'src/app/shared/tables-ibm';
import { selectAllOrders, selectOrderState } from 'src/app/redux/selectors/orders.selectors';
import { OrderBoard } from 'src/app/shared/interfaces/order.interface';

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['../../shared/styles/body.scss'],
  //changeDetection: ChangeDetectionStrategy.OnPush // Aplica la estrategia OnPush

})
export class OrderListComponent extends TablesIBMClass implements OnInit, OnDestroy {
  public user!: User;
  private orders: Order[] = [];
  private ordersSelected: Order[] = [];
  public title: string = "Listado de ordenes";

  //Filters
  orderBoard!: OrderBoard;
  conditionTypeSelected: string = '';
  search: string = '';
  conditionFilter: number[] = [];

  private user$!: Subscription;
  private order$!: Subscription;
  private orders$!: Subscription;
  private conditionType$!: Subscription;
  private title$!: Subscription;
  private search$!: Subscription;
  private conditionFilter$!: Subscription;

  constructor(private store: Store<appState>,
    private checker: SessionChecker,
    maestroSvc: MaestrosService, private dataRefreshService: DataRefreshService) {
    super(maestroSvc);
    this.loadOrders();
    this.checker.rememberAndActualizateUser(this.store);

    this.store.dispatch(setLocation({ location: NAVEGATION.ORDER_BOARD }));
    this.store.dispatch(setHeaderInMobile({ header: "Listado de ordenes" }));
  }

  setSubscriptions() {
    this.user$ = this.store.select('usuario').subscribe((usuario: User) => {
      if (this.user?.area != usuario.area) {
        this.user = usuario;
        this.setOrders(this.orders ?? [])
      }
      this.user = usuario;
    })

    //En caso de producirse un cambio en las ordenes, se actualiza el listado de ordenes
    this.orders$ = this.store.select(selectAllOrders).subscribe((orders) => {
      this.orders = orders;
      this.setOrders(this.orders ?? [])
    });


    this.order$ = this.store.select('order').subscribe((orderR) => {
      this.orders = orderR.orderBoard.all;
      this.ordersSelected = orderR.orderBoard.ordersSelected;

      //Filters
      //En caso de producirse un cambio en los filtros, se actualiza el listado de ordenes
      if (this.orderBoard?.filter != orderR.orderBoard.filter ||
        this.orderBoard?.buyerType != orderR.orderBoard.buyerType) {
        this.orderBoard = orderR.orderBoard;
        this.setOrders(this.orders);
      }
    });

    this.title$ = this.store.select('options', 'headerInMobile').subscribe(headerInMobile => {
      this.title = headerInMobile;
    });

    this.conditionType$ = this.store.select('options', 'board', 'conditionTypeSelected').subscribe(conditionType => {
      //En caso de producirse un cambio en el filtro de busqueda, se actualiza el listado de ordenes
      if (this.conditionTypeSelected != conditionType) {
        this.conditionTypeSelected = conditionType;
        this.setOrders(this.orders);
      }
    });

    this.search$ = this.store.select('options', 'board', 'search').subscribe(search => {
      //En caso de producirse un cambio en el filtro de busqueda, se actualiza el listado de ordenes
      if (this.search != search) {
        this.search = search;
        this.setOrders(this.orders);
      }
    });

    this.conditionFilter$ = this.store.select('options', 'board', 'conditionFilter').subscribe(conditionFilter => {
      //En caso de producirse un cambio en el filtro de busqueda, se actualiza el listado de ordenes
      this.conditionFilter = conditionFilter;
      this.setOrders(this.orders);
    });

  }

  ngOnInit(): void {
    this.setSubscriptions();
    this.checkTables();
  }

  ngOnDestroy(): void {
    this.user$?.unsubscribe();
    this.order$?.unsubscribe();
    this.orders$?.unsubscribe();
    this.conditionType$?.unsubscribe();
    this.title$?.unsubscribe();
    this.search$?.unsubscribe();
    this.conditionFilter$?.unsubscribe();

    this.store.dispatch(resetLastUpdate());
  }


  /*override functionToMessage(event: any): void {
    console.log(JSON.parse(event.data))
    if(event.data !== JSON.stringify(this.orders)){
      const orders=JSON.parse(event.data);
      let almacenamiento= !orders? []: orders;
      localStorage.setItem(localStorageNames.ordersAll, JSON.stringify(almacenamiento));

      this.store.dispatch(loadOrdersAllPrevius({orders: this.count==0? almacenamiento: JSON.parse(JSON.stringify(this.orders))}));
      this.count++;

      this.store.dispatch(loadOrdersAllSuccess({orders: almacenamiento}));
      
      this.setOrders(almacenamiento)
      setTimeout(() =>{
        this.store.dispatch(loadOrdersAllPrevius({orders: JSON.parse(JSON.stringify(almacenamiento))}));
      },3000); //3 segundos dura la animación
    }
  }*/

  //Esto es lo mismo que está en el panel de control.
  loadOrders() {
    this.dataRefreshService.refreshOrders(false);
  }

  /* This function create an orderList with Pipes */
  getOrderListWithPipes(orders: Order[]) {
    try {
      return getOrderListWithPipes(orders, this.user, this.orderBoard.filter,
        this.search, this.orderBoard.buyerType, this.conditionTypeSelected, this.conditionFilter)
    } catch (error) {
      return orders;
    }
  }

  setOrders(orders: Order[]) {
    this.store.dispatch(loadOrdersAllWithPipesSuccess({ orders: this.getOrderListWithPipes(orders) }))
  }
}